import React from 'react';
import StepFreeForm from './step-free-form';
import StepDropdown from './step-dropdown';
import StepDetails from './step-details';
import StepFinishStatus from './step-finish-status';
import StepQuiz from './step-quiz';
import { withDataCapture } from './with-data-capture';
import FormSpinner from '../../../sso/components/common/utility/FormSpinner';

class WizardDashboard extends React.Component {
    constructor(props) {
        super(props);
        const { steps } = props.options;

        const initialResult = {};
        for (let i = 0; i < steps.length; i++) {
            const item = steps[i];
            initialResult[item.itemDestinationName] = item.templateName === 'RadioField' ? item.possibleChoices[0] : '';
        }

        this.state = {
            wizardIndex: 0,
            canGoToNextStep: steps && steps[0] && steps[0].isOptional,
            viewErrors: false,
            emailAddress: '',
            result: initialResult
        };
        this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
        this.handlePreviousButtonClick = this.handlePreviousButtonClick.bind(this);
        this.displayCurrentStep = this.displayCurrentStep.bind(this);
        this.updateResult = this.updateResult.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.loading && nextProps.responseReceived) {
            this.setState({
                wizardIndex: this.state.wizardIndex + 1,
                canGoToNextStep: false,
                viewErrors: this.state.viewErrors,
                emailAddress: this.state.emailAddress,
                result: this.state.result
            });
        }
    }

    handleNextButtonClick(event) {
        event.preventDefault();
        const { wizardIndex, canGoToNextStep } = this.state;
        const { steps } = this.props.options;

        if (!canGoToNextStep) {
            this.setState({
                wizardIndex: this.state.wizardIndex,
                canGoToNextStep: false,
                viewErrors: true,
                emailAddress: this.state.emailAddress,
                result: this.state.result
            });
            return;
        }
        //validate if can go next

        if (wizardIndex === steps.length) {
            this.props.handleDataCapture(this.state.result, this.state.emailAddress, this.props.options.addressBookID, this.props.options.itemId);
            return;
        }
        const nextStep = this.props.options.steps[this.state.wizardIndex + 1];

        this.setState({
            wizardIndex: this.state.wizardIndex + 1,
            canGoToNextStep: nextStep && (nextStep.isOptional || nextStep.templateName === 'RadioField'),
            viewErrors: false,
            emailAddress: this.state.emailAddress,
            result: this.state.result
        });
    }

    handlePreviousButtonClick(event) {
        event.preventDefault();

        this.setState({
            wizardIndex: this.state.wizardIndex - 1,
            canGoToNextStep: true,
            viewErrors: false,
            emailAddress: this.state.emailAddress,
            result: this.state.result
        });
    }

  updateResult = (canGoToNextStep, parameterName, parameterValue) => {
      if (!parameterName) {
          this.setState({
              wizardIndex: this.state.wizardIndex,
              canGoToNextStep,
              viewErrors: this.state.viewErrors,
              emailAddress: this.state.emailAddress,
              result: this.state.result
          });
          return;
      }

      const newEmailAddress = (parameterName === 'emailAddress') ? parameterValue : this.state.emailAddress;

      if (parameterName !== 'emailAddress' && this.state.result[parameterName] !== parameterValue) {
          const partialResult = this.state.result;
          partialResult[parameterName] = parameterValue;
          this.setState({
              wizardIndex: this.state.wizardIndex,
              canGoToNextStep,
              viewErrors: this.state.viewErrors,
              emailAddress: newEmailAddress,
              result: partialResult
          });
      } else {
          this.setState({
              wizardIndex: this.state.wizardIndex,
              canGoToNextStep,
              viewErrors: this.state.viewErrors,
              emailAddress: newEmailAddress,
              result: this.state.result
          });
      }
  }

  displayCurrentStep() {
      const { options, succeeded } = this.props;
      const {
          wizardIndex, emailAddress, canGoToNextStep, result, viewErrors
      } = this.state;

      // TODO: Verify steps
      // TODO: If wizardIndex equals steps length set Details  as the current step

      if (wizardIndex === options.steps.length) {
          return <StepDetails
              options={options}
              updateResult={this.updateResult}
              emailAddress={emailAddress}
              initialResult={result}
              viewErrors={viewErrors}
              canGoToNextStep={canGoToNextStep}
          />;
      }

      if (wizardIndex === options.steps.length + 1) {
          const message = succeeded ? options.successfullySubmittedMessage : options.errorSubmissionMessage;
          const statusClass = succeeded ? 'message-success' : 'message-error';

          return <StepFinishStatus message={message} statusClass={statusClass} />;
      }
      const item = options.steps[wizardIndex];

      if (item.templateName === 'DropdownField') {
          return <StepDropdown
              options={item}
              initialResult={this.state.result}
              updateResult={this.updateResult}
              viewErrors={viewErrors}
              canGoToNextStep={canGoToNextStep}
          />;
      }

      if (item.templateName === 'RadioField') {
          return <StepQuiz
              options={item}
              initialResult={this.state.result}
              updateResult={this.updateResult}
              viewErrors={viewErrors}
              canGoToNextStep={canGoToNextStep}
          />;
      }

      if (item.templateName === 'TextField') {
          return <StepFreeForm
              options={item}
              initialResult={this.state.result}
              updateResult={this.updateResult}
              viewErrors={viewErrors}
              canGoToNextStep={canGoToNextStep}
              textMaximumLength={options.textMaximumLength}
          />;
      }

      return null;
  }

  render() {
      const { options, loading } = this.props;
      const {
          nextButtonText,
          submitButtonText,
          hasTheOneClubLayout,
          pagesBackgroundImageSource
      } = options;
      const { wizardIndex } = this.state;

      const showNextButton = wizardIndex < options.steps.length + 1;
      const showBackButton = wizardIndex > 0 && wizardIndex < options.steps.length + 1;

      const nextSubmitButtonText =
      wizardIndex === options.steps.length ? submitButtonText : nextButtonText;

      return (
          <div
              className={`content ${hasTheOneClubLayout ? 'the-one-club' : null}`}
              style={{
                  backgroundImage: 'url(' + pagesBackgroundImageSource + ')'
              }}
          >
              {loading ? <FormSpinner></FormSpinner> : null}
              <div className="title">{options.title}</div>
              <div className="sub-title">{options.description}</div>
              <div id="regForm" action="">
                  {this.displayCurrentStep()}
                  <div className="quiz-button-container">
                      {
                          showBackButton &&
              <button
                  className="button button--primary"
                  type="button"
                  id="prevBtn"
                  onClick={this.handlePreviousButtonClick}>
                  {options.backButtonText}
              </button>
                      }
                      {
                          showNextButton &&
              <button
                  className="button button--primary"
                  type="button"
                  id="nextBtn"
                  onClick={this.handleNextButtonClick}
              >
                  {nextSubmitButtonText}
              </button>
                      }
                  </div>
              </div>
          </div >
      );
  }
}

export default withDataCapture(WizardDashboard);
